import { render } from "./ItemBatchDetailsModal.vue?vue&type=template&id=3642747a&scoped=true"
import script from "./ItemBatchDetailsModal.vue?vue&type=script&lang=js"
export * from "./ItemBatchDetailsModal.vue?vue&type=script&lang=js"

import "./ItemBatchDetailsModal.vue?vue&type=style&index=0&id=3642747a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3642747a"]])

export default __exports__